import BaseSocket, { SocketOptions } from "../base";
import { CustomerLocationResponseType, CustomerType, DriverStateDataType, DriverType } from "./types";
import { ETAType, LocationAndEtaDetailType } from "../base/types";
import locationTracker from "../location";

export type ServiceTypeType = 'OWD' | 'TWD';

export type FinalLocationType = {
  place: string,
  latitude: number,
  longitude: number,
}

class DriverSocket extends BaseSocket<DriverStateDataType> {
  constructor(opts: SocketOptions) {
    super({ requestFrom: 'Driver', ...opts });
    this.on('serviceStatus', (data: DriverStateDataType) => {
      this.setState(({ data: prevData }) => {

        let nextData = { ...data };
        let { statusCode, customer, ride } = data;
        switch (statusCode) {
          case 302:
          case 301:
          case 309:
          case 310:
          case 312:
          case 303:
          case 313:
          case 311:
            if (!customer) {
              customer = prevData.customer || undefined;
            }
            if (!ride) {
              ride = prevData.ride || undefined;
            }
            if(customer && prevData.customer) {
              if (!customer.location && prevData.customer.location) {
                customer = { ...customer, location: prevData.customer.location };
              }
            }
            if (ride && prevData.ride) {
              if (!ride.origin && prevData.ride.origin) {
                ride = { ...ride, origin: prevData.ride.origin };
              }
              if (!ride.destination && prevData.ride.destination) {
                ride = { ...ride, destination: prevData.ride.destination };
              }
            }
            nextData.customer = customer;
            nextData.ride = ride;
            break;
        }
        return { data: nextData };
      });
    });
    this.on('getCustomerLocation', (data: CustomerLocationResponseType) => {
      this.setState(({ data: prevData }) => {
        let nextData = { ...prevData };
        let { customerLocation } = data;
        let customer = prevData.customer || {} as CustomerType;
        customer.location = customerLocation;
        nextData.customer = customer;
        return { data: nextData };
      })
    })
  }
  onLocationUpdate = (locationWithEta: LocationAndEtaDetailType) => {
    this.sendLocationWithEta(locationWithEta);
  }
  sendLocationWithEta = (locationWithEta: LocationAndEtaDetailType) => {
    const { data } = this.state;
    const { userId, ride, customer, statusCode } = data;
    const payload = {
      location: locationWithEta.location,
      driverId: userId,
    }
    if (locationWithEta.accuracy) {
      // @ts-ignore
      payload.accuracy = locationWithEta.accuracy
    }
    if (locationWithEta.bearing) {
      // @ts-ignore
      payload.bearing = locationWithEta.bearing
    }
    if (locationWithEta.speed) {
      // @ts-ignore
      payload.speed = locationWithEta.speed
    }
    if (locationWithEta.altitude) {
      // @ts-ignore
      payload.altitude = locationWithEta.altitude
    }
    switch (statusCode) {
      case 301:
      case 302:
      case 312:
      case 303:
      case 313:
      case 311:
        if (customer) {
          // @ts-ignore
          payload.customerId = customer.customerId;
        }
        if (ride) {
          // @ts-ignore
          payload.rideId = ride.rideId;
        }
        if (locationWithEta.eta) {
          // @ts-ignore
          payload.eta = locationWithEta.eta;
        }
    }
    this.emit('updateLocation', payload)
  }
  goOnline = () => {
    const { data } = this.state;
    const { statusCode, userId } = data
    if (statusCode !== 305) {
      this.throw('Can go online only if currently Not available (statusCode=305)');
    }
    const payload = {
      driverId: userId,
      location: locationTracker.location.location,
      token: this.token || '',
      online: true
    }
    this.emit('changeStatus', payload);
  }
  goOffline = () => {
    const { data } = this.state;
    const { statusCode, userId } = data
    if (statusCode !== 300) {
      this.throw('Can go offline only if currently Idle (statusCode=300)');
    }
    const payload = {
      driverId: userId,
      location: locationTracker.location.location,
      token: this.token || '',
      online: false
    }
    this.emit('changeStatus', payload);
  }
  rejectCall = () => {
    const { data } = this.state;
    const { statusCode, userId, ride } = data
    if (statusCode !== 301) {
      this.throw('Can reject call only if currently calling (statusCode=301)');
    }
    if (!ride) {
      this.throw("Cannot accept call if there's no ride");
    }
    const payload = {
      driverId: userId,
      location: locationTracker.location.location,
      token: this.token || '',
      // @ts-ignore
      rideId: ride.rideId,
    }
    this.emit('rejectCall', payload);
  }
  acceptCall = (driver: DriverType, eta?: ETAType) => {
    const { data } = this.state;
    const { statusCode, userId, ride, customer } = data
    if (statusCode !== 301) {
      this.throw('Can accept call only if currently calling (statusCode=301)');
    }
    if (!ride) {
      this.throw("Cannot accept call if there's no ride");
    }
    if (!customer) {
      this.throw("Cannot accept call if there's no customer");
    }
    const payload = {
      driverId: userId,
      driver,
      location: locationTracker.location.location,
      eta: eta || locationTracker.location.eta,
      token: this.token || '',
    // @ts-ignore
      rideId: ride.rideId,
    // @ts-ignore
      customerId: customer.customerId
    }
    this.emit('acceptCall', payload);
  }
  abortRide = (eta?: ETAType) => {
    const { data } = this.state;
    const { statusCode, userId, ride, customer } = data
    if (statusCode !== 302) {
      this.throw('Can abort ride only if currently on the way (statusCode=302)');
    }
    if (!ride) {
      this.throw("Cannot abort ride if there's no ride");
    }
    if (!customer) {
      this.throw("Cannot abort ride if there's no customer");
    }
    const payload = {
      driverId: userId,
      location: locationTracker.location.location,
      eta: eta || locationTracker.location.eta,
      token: this.token || '',
      // @ts-ignore
      rideId: ride.rideId,
      // @ts-ignore
      customerId: customer.customerId,
    }
    this.emit('abortRide', payload);
  }
  startRide = () => {
    const { data } = this.state;
    const { statusCode, userId, ride, customer } = data
    if (statusCode !== 302) {
      this.throw('Can start ride only if currently on the way (statusCode=302)');
    }
    if (!ride) {
      this.throw("Cannot start ride if there's no ride");
    }
    if (!customer) {
      this.throw("Cannot start ride if there's no customer");
    }
    const payload = {
      driverId: userId,
      location: locationTracker.location.location,
      token: this.token || '',
      // @ts-ignore
      rideId: ride.rideId,
      // @ts-ignore
      customerId: customer.customerId,
    }
    this.emit('startRide', payload);
  }
  endRide = (serviceType: ServiceTypeType, waitingTimeInMinutes: Number, finalLocation: FinalLocationType) => {
    // @ts-ignore
    if (serviceType !== 'OWD' || serviceType !== 'TWD') {
      this.throw('Service type must be either "OWD" or "TWD"');
    }
    if (typeof waitingTimeInMinutes !== 'number') {
      this.throw('WaitingTimeInMinutes must be a number');
    }
    let finalLocationValid = false;
    let finalLocationType: string = typeof finalLocation;
    if (finalLocationType === 'object') {
      if (!finalLocation) {
        finalLocationType = 'null';
      }
      finalLocationType = `{ ${Object.entries(finalLocation)
        .map(([k, v]) => `${k}: ${typeof v}`)
        .join(', ')} }`;
      if (typeof finalLocation.place === 'string' &&
        typeof finalLocation.latitude === "number" &&
        typeof finalLocation.longitude === "number") {
        finalLocationValid = true;
      }
    }
    if (!finalLocationValid) {
      this.throw(`Final Location must be of type { place: string, location: number, latitude: number } but is of type ${finalLocationType}`);
    }
    const { data } = this.state;
    const { statusCode, userId, ride, customer } = data
    if (statusCode !== 303) {
      this.throw('Can end ride only if currently enroute (statusCode=303)');
    }
    if (!ride) {
      this.throw("Cannot end ride if there's no ride");
    }
    if (!customer) {
      this.throw("Cannot end ride if there's no customer");
    }
    const payload = {
      driverId: userId,
      location: finalLocation,
      serviceType,
      waitingTime: waitingTimeInMinutes,
      token: this.token || '',
      // @ts-ignore
      rideId: ride.rideId,
      // @ts-ignore
      customerId: customer.customerId,
    }
    this.emit('endRide', payload);
  }
}

export default DriverSocket;
